"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversations.delete.tooltip': 'Elimina conversazione',
    'conversations.delete.confirm': 'Sei sicuro di voler eliminare "{title}"? Questa azione non può essere annullata.',
};
